import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FerienhauserofferComponent } from './ferienhauseroffer.component';

const routes: Routes = [
    {
        path: '',
        component: FerienhauserofferComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FerienhauserofferRoutingModule { }
